var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('badge');
import { breakpoints, theme } from '@shapeable/theme';
import { isString } from 'lodash';
import { useComponentPropsFor } from '../context/component-props-context';
export var BadgeDefaultProps = {
  // isPending: false,
  showBorder: false,
  colors: {
    background: 'primary',
    text: 'light',
    border: 'light'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    text-transform: uppercase;\n    white-space: nowrap;\n    align-items: center;\n\n    ", ";\n    \n    font-weight: 600;\n    border-radius: 20px;\n    font-size: ", ";\n    padding: 0 ", ";\n    height: 20px;\n\n    ", "\n    \n  "], ["\n    display: flex;\n    text-transform: uppercase;\n    white-space: nowrap;\n    align-items: center;\n\n    ", ";\n    \n    font-weight: 600;\n    border-radius: 20px;\n    font-size: ", ";\n    padding: 0 ", ";\n    height: 20px;\n\n    ", "\n    \n  "])), theme.APPLY_COLORS, theme.FONT_SIZE(11), theme.UNIT(2), function (props) {
    return props.hasBorder && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-width: 1px;\n      border-style: solid;\n    "], ["\n      border-width: 1px;\n      border-style: solid;\n    "])));
  })
});
// -------- Components -------->
var My = {
  NAME: 'Badge',
  Container: styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Badge = function (props) {
  var _a = useComponentPropsFor(My.NAME, BadgeDefaultProps, props),
    className = _a.className,
    children = _a.children,
    colors = _a.colors,
    showBorder = _a.showBorder;
  return React.createElement(My.Container, {
    colors: colors,
    title: isString(children) && children,
    hasBorder: showBorder,
    // isPending={isPending} 
    className: cls.name(className)
  }, children);
};
Badge.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;